import { fetchJSON } from "./utils";

export async function fetchInteractionPageCounts(organization_id = null) {
  const params = {};
  if (organization_id) {
    params.organization_id = organization_id;
  }
  const url = `/api/counts/interactions`;
  return fetchJSON(url, params, null, "get", false);
}

export async function fetchTrainingPageCounts(organization_id = null) {
  const params = {};
  if (organization_id) {
    params.organization_id = organization_id;
  }
  const url = `/api/counts/trainings`;
  return fetchJSON(url, params, null, "get", false);
}

export async function fetchUserCategoryCounts(organization_id = null) {
  const params = {};
  if (organization_id) {
    params.organization_id = organization_id;
  }
  const url = `/api/counts/user-category-counts`;
  return fetchJSON(url, params, null, "get", false);
}
